import { z } from 'zod';

export const PRODUCT_EVENTS = {
  NewBid: 'new_bid',
  LockBid: 'lock_bid',
  UnlockBid: 'unlock_bid',
  OpenBidding: 'open_bidding',
  CloseBidding: 'close_bidding',
} as const;

export const ProductEventEnum = z.nativeEnum(PRODUCT_EVENTS);

export const ProductEventSchemas = {
  [PRODUCT_EVENTS.NewBid]: z.object({
    productId: z.string(),
    auctionId: z.string().optional(),
  }),
  [PRODUCT_EVENTS.LockBid]: z.object({
    productId: z.string(),
    auctionId: z.string().optional(),
  }),
  [PRODUCT_EVENTS.UnlockBid]: z.object({
    productId: z.string(),
    auctionId: z.string().optional(),
  }),
  [PRODUCT_EVENTS.OpenBidding]: z.object({
    productId: z.string(),
    auctionId: z.string().optional(),
  }),
  [PRODUCT_EVENTS.CloseBidding]: z.object({
    productId: z.string(),
    auctionId: z.string().optional(),
  }),
} as const;
export type ProductEventPayloads = {
  [K in keyof typeof PRODUCT_EVENTS]: z.infer<(typeof ProductEventSchemas)[(typeof PRODUCT_EVENTS)[K]]>;
};

type ValidatedProductEvent = {
  [K in keyof typeof PRODUCT_EVENTS]: {
    event: (typeof PRODUCT_EVENTS)[K];
    data: ProductEventPayloads[K];
  };
}[keyof typeof PRODUCT_EVENTS];
export function validateProductEvent(payload: { event: string; data: unknown }): ValidatedProductEvent {
  const parsedPayload = z
    .object({
      event: ProductEventEnum,
      data: z.unknown(),
    })
    .parse(payload);

  const schema = ProductEventSchemas[parsedPayload.event];
  const parsedData = schema.parse(parsedPayload.data);

  return {
    event: parsedPayload.event,
    data: parsedData,
  } as ValidatedProductEvent;
}
